import { render } from "./report.vue?vue&type=template&id=0db424af&scoped=true"
import script from "./report.vue?vue&type=script&lang=js"
export * from "./report.vue?vue&type=script&lang=js"

import "./report.vue?vue&type=style&index=0&id=0db424af&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-0db424af"

export default script